import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { EReplyStatus } from 'src/app/models/recipients.model';

@Component({
    selector: 'que-questionnaire-status-to-user',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './questionnaire-status-to-user.component.html',
    styleUrls: ['./questionnaire-status-to-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionnaireStatusToUserComponent {
@Input()
status?:EReplyStatus
enumQStatus=EReplyStatus;
}
